module.exports = __webpack_public_path__ + "img/cloud-upload.dc1b7db8.png";